export const buildGetParamsFromObject = (params: Record<string, string | string[] | undefined>): string => {
  const query = Object.entries(params)
    .filter(([k, v]) => v)
    .map(([key, value]) => {
      if (Array.isArray(value)) {
        return value.map((v) => `${encodeURIComponent(key)}=${encodeURIComponent(v)}`).join('&');
      }
      return value?.length ? `${encodeURIComponent(key)}=${encodeURIComponent(value)}` : '';
    }).join('&');
  return query ? `${query}` : '';
};
